<script>
import button from '../mixins/button';
import iconImg from '../images/center.png';

export default {
    name: 'CenterButton',
    mixins: [button],
    data() {
        return {
            name: 'Center Image',
            icon: 'fa-align-center',
            toolTipText: {
                // 工具提示
                zh: '图片居中', // 中文
                en: 'Center Image', // 英文
            },
            iconImage: iconImg,
            iconImageActive: iconImg,
        };
    },
    methods: {
        execute() {
            this.$parent.fit();
        },
    },
};
</script>
